import React from 'react';
import styled from 'styled-components';
import { projects } from '../../data/projects';
import HomeProjectCard from './HomeProjectCard';

const Section = styled.section`
  padding: clamp(72px, 10vw, 120px) 0;
  background: ${({ theme }) => theme.colors.bgMuted};
`;

const Container = styled.div`
  width: min(${({ theme }) => theme.layout.content}, calc(100% - 40px));
  margin: 0 auto;
`;

const Header = styled.div`
  max-width: 660px;
  margin-bottom: 44px;
`;

const Title = styled.h2`
  margin: 0 0 12px;
  font-size: clamp(2.4rem, 6vw, 4.4rem);
  line-height: 1;
  letter-spacing: -0.055em;
`;

const Intro = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 1.08rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

const ProjectGrid: React.FC = () => (
  <Section id="projects" data-testid="projects-section">
    <Container>
      <Header>
        <Title>Selected work</Title>
        <Intro>From Apple-platform utilities and AI-native stories to tourism training and creative production workflows.</Intro>
      </Header>
      <Grid>
        {projects.map((project, index) => <HomeProjectCard key={project.slug} project={project} index={index} />)}
      </Grid>
    </Container>
  </Section>
);

export default ProjectGrid;
